<template>
    <div class="ol-product-content__center-list">

        <div v-for="(product,i) in products" :key="'item-'+i+'-'+product.id+'-'+product.slug">
            <router-link :to="product.bundling == 1 ? '/bundle/'+product.slug : '/product/'+product.slug" :title="product.name">
                <div class="ol-home-product__content-item-list--item" >
                    <div class="more-product-item">
                        <figure class="ol-home-product__content-item-list--item-figure">
                            
                            <div v-if="product.stock == 0" class="label-stock-empty" >Stok Habis</div>
                            <div v-if="product.stock == 0" class="image-stock-empty" ></div>
                            <span v-if="product.r_uni_product_suasanas">
                                <div v-for="(image,i) in product.r_uni_product_suasanas.slice(0, 3)" :key="image.id" :class="'ol-home-product__content-item-list--item-figure-link ol-home-product__content-item-list--item-figure-link--'+(i+1)">
                                    <img :src="image.image_url" :alt="image.alt_text" :title="product.name">
                                </div>
                            </span>
                            <span v-if="product.r_uni_product_images && product.r_uni_product_suasanas.length < 1">
                                <div v-for="(image,i) in product.r_uni_product_images.slice(0, 3)" :key="image.id" :class="'ol-home-product__content-item-list--item-figure-link ol-home-product__content-item-list--item-figure-link--'+(i+1)">
                                    <img :src="image.image_url" :alt="image.alt_text" :title="product.name">
                                </div>
                            </span>
                            <span>
                                <div v-if="product.r_uni_product_images.length == 0 && product.r_uni_product_suasanas.length == 0 " class="'ol-home-product__content-item-list--item-figure-link ol-home-product__content-item-list--item-figure-link--1">
                                    <img src="https://cdn.morefurniture.id/images/noimage.png">
                                </div>
                            </span>
                            <div v-if="product.seo_4 == 'GRATIS'" class="promotion-free">
                                <span class="one-lines"><b>{{ product.seo_4 }}</b>&nbsp;{{ product.seo_5 }}</span>
                            </div>
                            <div v-if="product.seo_4 == 'FLASH SALE'" class="promotion-flashsale">
                                <span class="one-lines"><b>{{ product.seo_4 }}</b>&nbsp;{{ product.seo_5 }}</span>
                            </div>
                            <div v-if="product.seo_4 == 'KOMBO HEMAT'" class="promotion-combo">
                                <span class="one-lines"><b>{{ product.seo_4 }}</b>&nbsp;{{ product.seo_5 }}</span>
                            </div>
                            <div v-if="product.seo_4 == 'SALE'" class="promotion-free">
                                <span class="one-lines">{{ product.seo_5 }}</span>
                            </div>
                            <span v-if="product.seo_4 == 'HOT PRODUCT'" class="item-hot"><img  :src="require('@/assets/images/benefit/HOT PRODUCT.png')" style="height:20px;"/></span>
                            <span v-if="product.seo_4 == 'NEW PRODUCT'" class="item-hot"><img  :src="require('@/assets/images/benefit/NEW PRODUCT.png')" style="height:20px;"/></span>
                            <span v-if="product.seo_4 == 'SPOOKY SALE'" class="item-hot"><img  :src="require('@/assets/images/benefit/spooky-sale.png')" style="height:20px;"/></span>
                        </figure>
                        <h3 class="ol-home-product__content-item-list--item-title">
                            {{product.name}}
                        </h3>
                        <span v-if="product.discount_max && product.discount_max != '0%'" class="ol-home-product__content-item-list--item-discount">{{product.discount_max}}<br>OFF</span>
                        
                        
                        <div class="ol-home-product__content-item-list--item-price">
                            <span class="ol-home-product__content-item-list--item-price-real">{{product.price_normal_min}}</span>
                            <small class="ol-home-product__content-item-list--item-price-discount">{{product.price_discount_min}}</small>
                        </div>
                        <span v-if="product.total_sales != 0"><i class="fas fa-star" style="color:gold;"></i> {{product.rating}} | {{product.total_sales}} Terjual</span>
                        <span v-if="product.total_sales == 0">&nbsp;</span>
                    </div>
                    
                </div>
            </router-link>
        </div>
        
    </div>
</template>

<script>

export default {
    name:"ProductList",
    props:["products"],
}
</script>

<style>

.label-free-product {
  /* height: 35px; */
  border-radius: 0px 0px 8px 8px;
  padding: 8px;
  background: #C13B37;
  margin: -8px 2px 4px 2px;
  color: white;
  font-size: 10px;
  text-align: left;
}

.label-free {
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  max-height: 24px;
  line-height: 12px;
}

</style>